import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Clean component imports using organized folder structure
import {
  Navbar,
  Hero,
  QuestionsSection,
  DailyReflections,
  GuidanceSection,
  TestimonialSection,
  FooterSection,
  RealGuidanceSection,
  ComingSoonSection,
  TermsAndConditions,
  PrivacyPolicy
} from './components';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={
          <>
            <Hero />
            <QuestionsSection />
            <DailyReflections />
            <GuidanceSection />
            <RealGuidanceSection />
            <ComingSoonSection />
            <TestimonialSection />
          </>
        } />
        <Route path="/tnc" element={<TermsAndConditions />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        {/* Data deletion now served as static HTML at /datadeletion.html */}
      </Routes>
      <FooterSection />
    </Router>
  );
}

export default App;
